import { call, put, takeLatest, select } from 'redux-saga/effects'
import { handleApiErrors } from '../../lib/api-errors'
import axiosApi from '../../views/client/axiosClient'

import * as Constants from './constants'

import * as brActions from './actions'

const getContractsState = state => state.contracts;

function handleRequest (request) {
  return request
    .then(handleApiErrors)
    .then( function(response){
      return response.data;
    })
    .then(json => json)
    .catch((error) => { throw error })
}

function listRequestApi (formData) {
  const request = axiosApi().post(
    Constants.CONTRACTS_LIST_API, 
    formData
  )

  return handleRequest(request);
}

function detailRequestApi (formData) {
  const request = axiosApi().post(
    Constants.CONTRACTS_DETAIL_API, 
    formData
  )

  return handleRequest(request);
}

function contractsUpdateRequestApi (formData) {
  const request = axiosApi().post(
    Constants.CONTRACTS_UPDATE_API, 
    formData
  )

  return handleRequest(request);
}

function loaiRequestApi (formData) {
  const request = axiosApi().post(
    Constants.CONTRACTS_LOAI_API, 
    formData
  )
  return handleRequest(request);
}

function trangThaiRequestApi (formData) {
  const request = axiosApi().post(
    Constants.CONTRACTS_TRANGTHAI_API, 
    formData
  )
  return handleRequest(request);
}

function nhanVienRequestApi (formData) {
  const request = axiosApi().post(
    Constants.CONTRACTS_NHANVIEN_API, 
    formData
  )
  return handleRequest(request);
}

function khachHangRequestApi (formData) {
  const request = axiosApi().post(
    Constants.CONTRACTS_KHACHHANG_API, 
    formData
  )

  return handleRequest(request);
}

function* contractsLoaiRequestFlow () {
  const contracts = yield select(getContractsState);
  try {
    // grab the client from our action
    const results = yield call(loaiRequestApi, contracts.formData)

    // dispatch the action with our widgets!
    yield put(brActions.contractsLoaiSuccess(results.data))

  } catch (error) {
    yield put(brActions.contractsLoaiError(error))
  }
}

function* contractsTrangThaiRequestFlow () {
  const contracts = yield select(getContractsState);
  try {
    // grab the client from our action
    const results = yield call(trangThaiRequestApi, contracts.formData)

    // dispatch the action with our widgets!
    yield put(brActions.contractsTrangThaiSuccess(results.data))

  } catch (error) {
    yield put(brActions.contractsTrangThaiError(error))
  }
}

function* contractsNhanVienRequestFlow () {
  const contracts = yield select(getContractsState);
  try {
    // grab the client from our action
    const results = yield call(nhanVienRequestApi, contracts.formData)

    // dispatch the action with our widgets!
    yield put(brActions.contractsNhanVienSuccess(results.data))

  } catch (error) {
    yield put(brActions.contractsNhanVienError(error))
  }
}

function* contractsListRequestFlow () {
  const contracts = yield select(getContractsState);
  try {
    // grab the client from our action
    const results = yield call(listRequestApi, contracts.formData)

    // dispatch the action with our widgets!
    yield put(brActions.contractsListSuccess(results.data))

  } catch (error) {
    yield put(brActions.contractsListError(error))
  }
}

function* contractsKhachHangRequestFlow () {
  const contracts = yield select(getContractsState);
  try {
    // grab the client from our action
    const results = yield call(khachHangRequestApi, contracts.formData)

    // dispatch the action with our widgets!
    yield put(brActions.contractsKhachHangSuccess(results.data))

    if (typeof contracts.callback == 'function')
    {
      yield contracts.callback(results);
    } 
  } catch (error) {
    yield put(brActions.contractsKhachHangError(error))
  }
}

function* contractsDetailRequestFlow () {
  const contracts = yield select(getContractsState);
  try {
    // grab the client from our action
    const results = yield call(detailRequestApi, contracts.formData)

    // dispatch the action with our widgets!
    yield put(brActions.contractsDetailSuccess(results.data))

  } catch (error) {
    yield put(brActions.contractsDetailError(error))
  }
}

function* contractsUpdateRequestFlow (action) {
  const contracts = yield select(getContractsState);
  try {
    // grab the client from our action
    const result = yield call(contractsUpdateRequestApi, contracts.formData)

    // dispatch the action with our widgets!
    yield put(brActions.contractsUpdateSuccess(result));
  } catch (error) {
    yield put(brActions.contractsUpdateError(error))
  }
}

function* contractsWatcher () {
  yield [
    takeLatest(Constants.CONTRACTS_LIST_REQUESTING, contractsListRequestFlow),
    takeLatest(Constants.CONTRACTS_DETAIL_REQUESTING, contractsDetailRequestFlow),
    takeLatest(Constants.CONTRACTS_UPDATE_REQUESTING, contractsUpdateRequestFlow),
    takeLatest(Constants.CONTRACTS_LOAI_REQUESTING, contractsLoaiRequestFlow),
    takeLatest(Constants.CONTRACTS_TRANGTHAI_REQUESTING, contractsTrangThaiRequestFlow),
    takeLatest(Constants.CONTRACTS_NHANVIEN_REQUESTING, contractsNhanVienRequestFlow),
    takeLatest(Constants.CONTRACTS_KHACHHANG_REQUESTING, contractsKhachHangRequestFlow), 
  ]
}

export default contractsWatcher



// WEBPACK FOOTER //
// ./src/views/Contracts/sagas.js